import script from "./part3.vue?vue&type=script&setup=true&lang=js"
export * from "./part3.vue?vue&type=script&setup=true&lang=js"

import "./part3.vue?vue&type=style&index=0&id=2e848de2&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\工作\\新旅视界网络科技有限公司\\达人令\\webapp\\drl-live-jk\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e848de2"]])

export default __exports__